import { deepClone } from '@/utils';

const app = {
    state: {
        routeNav: JSON.parse(sessionStorage.getItem('routeNav') || '[]'), // 整个的导航列表
        pageNav: [], // 导航列表
        taskId: null // 当前的详情页id值
    },
    mutations: {
        SET_PAGENAV: (state, list) => {
            state.pageNav = list;
        },
        SET_ROUTENAV: (state, list) => {
            state.routeNav = JSON.parse(JSON.stringify(list));
            sessionStorage.setItem('routeNav', JSON.stringify(state.routeNav));
        },
        ADD_ROUTENAV: (state, route) => {
            const index = state.routeNav.findIndex(it => it.url === route.url);
            if (index > -1) {
                state.routeNav = state.routeNav.slice(0, index + 1);
            } else {
                // 第一次加载且没有缓存的时候
                if (state.routeNav.length === 0 && route.matched.length > 2) {
                    const parent = route.matched[1];
                    state.routeNav = [
                        {
                            name: parent.meta.title,
                            url: parent.path
                        }
                    ];
                }
                state.routeNav.push(route);
            }
            sessionStorage.setItem('routeNav', JSON.stringify(state.routeNav));
        }
    },
    actions: {
        addRouteNav({ commit, state }, route) {
            commit('ADD_ROUTENAV', route);
        },
        setRouteNav({ commit, state }, list) {
            commit('SET_ROUTENAV', list);
        },
        addPageNavList({ commit, state }, list) {
            commit('SET_PAGENAV', list);
        },
        delPageNavList({ commit, state }) {
            commit('SET_PAGENAV', []);
        },
        changeTaskId({ state }, id) {
            state.taskId = id;
        }
    }
};

export default app;
